export default () => {
  return {
    signupModalOpen: false,
  }
}
